<template>
  <div class="bg-particles">
    <div v-for="n in 20" :key="n" class="particle" :style="particleStyle()"></div>
  </div>
</template>

<script setup>
const particleStyle = () => {
  const size = Math.random() * 4 + 1
  return {
    width: size + 'px',
    height: size + 'px',
    left: Math.random() * 100 + '%',
    top: Math.random() * 100 + '%',
    animationDuration: (Math.random() * 20 + 10) + 's',
    animationDelay: (Math.random() * 5) + 's',
    opacity: Math.random() * 0.5 + 0.1
  }
}
</script>

<style scoped>
.bg-particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.particle {
  position: absolute;
  background: #5eead4;
  border-radius: 50%;
  animation: floatParticle linear infinite;
}

@keyframes floatParticle {
  0% { transform: translateY(0) translateX(0); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { transform: translateY(-100vh) translateX(50px); opacity: 0; }
}
</style>
